<template>
    <v-row style="text-align:center;">
        <v-col v-if="!timeToSignOver">
            <qrcode-vue v-if="qrUrl" :value="qrUrl" level="H" :size="160"></qrcode-vue>
            <span>Воспользуетесь функцией сканер QR кодов в приложении электронного правительства «eGov Mobile»</span></v-col
        >
        <v-col v-else>
            <div class="ultraLightGrey d-flex justify-center align-center text-center" style="width: 160px; height: 160px">
                <span>Воспользуетесь функцией сканер QR кодов в приложении электронного правительства «eGov Mobile»</span>
            </div>
        </v-col>

        <v-col class="d-flex flex-column">
            <span class="mb-4">{{ $t('egovQr.useQrScanner') }}</span>
            <div v-if="!timeToSignOver" class="full-height">
                <div v-if="!signedData || signedData.status === 'DONT_SIGN'">
                    <div class="d-flex align-center">
                        <div>
                            <v-progress-circular
                                :rotate="-90"
                                :size="24"
                                :width="4"
                                color="green"
                                :value="percentForCircular"
                                class="mr-2"
                            ></v-progress-circular>
                        </div>
                        <div>{{ $t('egovQr.qrCodeExpiresIn') + ': ' + timeRemaining.minutes + ':' + timeRemaining.seconds }}</div>
                    </div>
                </div>

                <div v-else-if="signedData.status === 'SIGN'" class="d-flex align-center green--text">
                    <v-icon size="24" class="green--text">mdi-check</v-icon>
                    <span>Документ подписан!</span>
                </div>

                <div v-else class="d-flex full-height justify-space-between flex-column">
                    <div class="d-flex align-center red--text">
                        <v-icon size="24" class="red--text">mdi-close</v-icon>
                        <span>Документ не подписан!</span>
                    </div>

                    <v-hover v-slot="{ hover }">
                        <div class="d-flex align-center mb-2" @click="$emit('renewQrCode')">
                            <v-icon class="mr-1" color="primary">mdi-autorenew</v-icon>
                            <span class="primary--text cursor-pointer" :class="{ 'text-decoration-underline': hover }">{{
                                $t('egovQr.updateWaitingTime')
                            }}</span>
                        </div>
                    </v-hover>
                </div>
            </div>
            <div v-else>
                <v-hover v-slot="{ hover }">
                    <div class="d-flex align-center mb-2" @click="$emit('renewQrCode')">
                        <v-icon class="mr-1" color="primary">mdi-autorenew</v-icon>
                        <span class="primary--text cursor-pointer" :class="{ 'text-decoration-underline': hover }">{{ $t('egovQr.updateWaitingTime') }}</span>
                    </div>
                </v-hover>
                <div class="d-flex align-center">
                    <div>
                        <v-progress-circular :rotate="-90" :size="24" :width="4" color="green" :value="percentForCircular" class="mr-2"></v-progress-circular>
                    </div>
                    <div>{{ $t('egovQr.activeQrCodeExpired') }}</div>
                </div>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import SignService from '@/services/apiRequests/sign.service';

export default {
    components: {
        QrcodeVue
    },
    name: 'QRCodeSign',
    props: ['document', 'id', 'file_name'],
    data: () => ({
        sign_data: null,
        qrUrl: '',
        expireDate: null,
        timeToSignOver: null,
        signedData: {
            status: ''
        },
        timeRemaining: { minutes: 0, seconds: 0 },
        percentForCircular: null,
        signedInterval: null,
        updateTimerInterval: null
    }),
    computed: {
        ...mapState('sign', ['stylus_response', 'sign_response', 'qr_response', 'qr_check_response'])
    },
    async mounted() {
        await this.getQRLink(this.document);
    },
    methods: {
        ...mapActions('sign', ['postSign', 'requestToSign', 'checkSign']),
        async save() {
            await this.postSign({ guid: this.guid, sign_data: this.sign_data, is_engineer: this.is_engineer, is_qr: true });
        },
        updateTimer(targetDate) {
            const currentDate = new Date();
            const differenceInSeconds = Math.max(0, Math.floor((targetDate - currentDate) / 1000));
            const minutes = Math.floor(differenceInSeconds / 60);
            const seconds = differenceInSeconds % 60;
            if (minutes === 0 && seconds === 1) {
                clearInterval(this.updateTimerInterval);
                clearInterval(this.signedInterval);
                this.getQRLink();
            }
            this.timeRemaining = {
                minutes,
                seconds: seconds < 10 ? `0${seconds}` : seconds
            };
        },
        async checkIfSigned(guid) {
            const signData = await SignService.checkSign(guid);
            if (signData.status === 'SIGN') {
                const base64EncodedPDF = signData.data.documentsToSign[0].document.file.data;
                this.$emit('getQRData', base64EncodedPDF);
                clearInterval(this.updateTimerInterval);
                clearInterval(this.signedInterval);
                this.signedData.status = 'SIGN';
            } else {
                this.signedData.status = 'DONT_SIGN';
            }
        },
        async getQRLink() {
            const payload = {
                title: 'Подписание документа',
                organization: {
                    nameKz: 'АЛТС',
                    nameRu: 'АЛТС',
                    nameEn: 'АЛТС'
                },
                signMethod: 'CMS_WITH_DATA',
                documentsToSign: [
                    {
                        id: this.id,
                        nameRu: this.file_name,
                        nameKz: this.file_name,
                        nameEn: this.file_name,
                        meta: [
                            {
                                name: 'тип запроса',
                                value: 'Согласие'
                            }
                        ],
                        document: {
                            file: {
                                mime: '@file/pdf',
                                data: this.document
                            }
                        }
                    }
                ]
            };
            const response = await this.requestToSign(payload);
            this.qrUrl = `${this.qr_response.prefix}:${process.env.VUE_APP_QR_URL}/mgovSign/${this.qr_response.guid}`;
            this.expireDate = new Date(this.qr_response.expireDate);
            this.updateTimerInterval = setInterval(() => this.updateTimer(this.expireDate), 1000);
            this.signedInterval = setInterval(() => {
                this.checkIfSigned(response.guid);
            }, 3000);
        }
    }
};
</script>

<style lang="scss" scoped></style>
